module.exports = __webpack_public_path__ + "static/img/gl10.e8ba306.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/gl10.png
// module id = 9H8r
// module chunks = 3